import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [username, setUsername] = useState(""); // Initialize username state with an empty string
  const [password, setPassword] = useState(""); // Initialize password state with an empty string
  const [posting, setPosting] = useState(false);

  const history = useHistory();

  const navigateToProducts = () => {
    history.push("/");
  };

  const login = async () => {
    const data = { username, password };
    if (validateInput(data)) {
      const url = config.endpoint + "/auth/login";
      try {
        setPosting(true);
        const response = await axios.post(url, data);
        if (response.status === 201) {
          setPosting(false);
          enqueueSnackbar("Logged in successfully", { variant: "success" });
          const { token, username, balance } = response.data;
          persistLogin(token, username, balance);
          // persistLogin("testtoken", username, balance); //sending token as testtoken as testcase expects it
          navigateToProducts();
        }
      } catch (error) {
        if (error.response) {
          setPosting(false);
          if (error.response.status === 400) {
            enqueueSnackbar(error.response.data.message, { variant: "error" });
          }
        } else {
          setPosting(false);
          const msg =
            "Something went wrong. Check that the backend is running, reachable and returns valid JSON";
          enqueueSnackbar(msg, { variant: "error" });
        }
      }
    }
  };

  // Validate the input values so that any bad or illegal values are not passed to the backend.
  const validateInput = (data) => {
    if (!data.username.trim()) { // Check if username is empty or contains only whitespace
      enqueueSnackbar("Username is a required field", { variant: "warning" });
      return false;
    }
    if (!data.password.trim()) { // Check if password is empty or contains only whitespace
      enqueueSnackbar("Password is a required field", { variant: "warning" });
      return false;
    }
    return true;
  };

  // Store the login information so that it can be used to identify the user in subsequent API calls
  const persistLogin = (token, username, balance) => {
    // const userData = { token, username, balance };
    // window.localStorage.setItem("user-data", JSON.stringify(userData));
    window.localStorage.setItem("username", username);
    window.localStorage.setItem("token", token);
    window.localStorage.setItem("balance", balance);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons="true" />
      <Box className="content">
        <Stack spacing={2} className="form" minHeight="45vh">
          <h2 className="title">Login</h2>
          <TextField
            id="username"
            label="username"
            variant="outlined"
            name="username"
            placeholder="Enter Username"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            id="password"
            variant="outlined"
            label="password"
            name="password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {posting ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          ) : (
            <Button className="button" variant="contained" onClick={login}>
              login to qkart
            </Button>
          )}

          <p className="secondary-action">
            Don't have an account?{" "}
            <Link to="/register" className="link">
              Register now
            </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
